<mat-toolbar class="subtitulo">Matricula do beneficiário na atividade</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <div ngModelGroup="comboBeneficiario" fxFlex="50" fxLayoutGap="20px">
                    <combo-beneficiario [showDisplayId]="false" 
                                        [obrigatorio]="false" 
                                        [selecionado]="filtro.aluno"
                                        (valorChange)="onValorChange($event)">
                    </combo-beneficiario>
                </div>

                <mat-form-field fxFlex="50" fxFlexOffset="20px">
                    <mat-label>Selecione uma Atividade</mat-label>
                    <mat-select fxFlexOffset="20px" [(ngModel)]="atividade.id" name="atividade">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of atividades" [value]="d.id">
                            {{d.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>
            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="aluno">
                <th mat-header-cell *matHeaderCellDef> Beneficiário </th>
                <td mat-cell *matCellDef="let element"> {{ element.aluno.pessoaFisica.nome }} </td>
            </ng-container>

            <ng-container matColumnDef="atividade">
                <th mat-header-cell *matHeaderCellDef> Atividade </th>
                <td mat-cell *matCellDef="let element"> {{ element.atividade.descricao }} </td>
            </ng-container>

            <ng-container matColumnDef="dataInicioAtividade">
                <th mat-header-cell *matHeaderCellDef> Data de início  </th>
                <td mat-cell *matCellDef="let element"> {{element.dataInicioAtividade | dataSimples }} </td>
            </ng-container>

            <ng-container matColumnDef="dataCadastroAtividade">
                <th mat-header-cell *matHeaderCellDef> Data de cadastro </th>
                <td mat-cell *matCellDef="let element"> {{element.dataCadastroAtividade | dataSimples }} </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[20,30,50,100]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
            style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova atividade" mat-fab color="primary"
                    [routerLink]="menu ? ['/', menu, 'atividadealuno', 'cadastrar'] : ['/atividadealuno', 'cadastrar']"
                    routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>